import React from "react";
import { CustomIconProps } from "./add-01-solid-standard";

const HideIcon: React.FC<CustomIconProps> = ({
  size = 24,
  color = "#000000",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    color={color}
    fill={"none"}
    {...props}
  >
    <path
      d="M1.44541 7.16806C1.90493 6.8617 2.5258 6.98588 2.83216 7.44541C2.85837 7.48285 2.93295 7.58911 2.98827 7.66407C3.099 7.81408 3.26659 8.03284 3.48708 8.29742C3.92916 8.82792 4.57785 9.53538 5.4009 10.2408C7.06276 11.6653 9.33801 13.0001 12.0001 13.0001C14.6622 13.0001 16.9371 11.6653 18.599 10.2408C19.422 9.53538 20.0707 8.82792 20.5128 8.29742C20.7333 8.03284 20.9009 7.81408 21.0116 7.66407C21.0669 7.58911 21.1415 7.48285 21.1677 7.44541C21.4741 6.98588 22.095 6.8617 22.5545 7.16806C23.014 7.47441 23.1382 8.09528 22.8318 8.55481L22.8262 8.56282C22.786 8.62027 22.6834 8.76696 22.6208 8.85177C22.4893 9.02988 22.2975 9.27987 22.0493 9.57779C21.5538 10.1723 20.8275 10.9648 19.9006 11.7594C18.0624 13.3349 15.338 15.0001 12.0001 15.0001C8.6622 15.0001 5.93746 13.3349 4.09931 11.7594C3.17236 10.9648 2.44606 10.1723 1.95064 9.57779C1.70237 9.27987 1.51059 9.02988 1.37913 8.85177C1.31336 8.76267 1.20337 8.60526 1.16806 8.55481C0.861704 8.09528 0.985877 7.47441 1.44541 7.16806Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.70711 10.2929C5.09763 10.6834 5.09763 11.3166 4.70711 11.7071L2.70711 13.7071C2.31658 14.0976 1.68342 14.0976 1.29289 13.7071C0.902369 13.3166 0.902369 12.6834 1.29289 12.2929L3.29289 10.2929C3.68342 9.90237 4.31658 9.90237 4.70711 10.2929ZM19.2929 10.2929C19.6834 9.90237 20.3166 9.90237 20.7071 10.2929L22.7071 12.2929C23.0976 12.6834 23.0976 13.3166 22.7071 13.7071C22.3166 14.0976 21.6834 14.0976 21.2929 13.7071L19.2929 11.7071C18.9024 11.3166 18.9024 10.6834 19.2929 10.2929ZM9.5145 12.6425C9.98808 12.9267 10.1416 13.5409 9.85749 14.0145L8.35749 16.5145C8.07334 16.9881 7.45908 17.1416 6.9855 16.8575C6.51192 16.5733 6.35836 15.9591 6.64251 15.4855L8.14251 12.9855C8.42666 12.5119 9.04092 12.3584 9.5145 12.6425ZM14.4855 12.6425C14.9591 12.3584 15.5733 12.5119 15.8575 12.9855L17.3575 15.4855C17.6416 15.9591 17.4881 16.5733 17.0145 16.8575C16.5409 17.1416 15.9267 16.9881 15.6425 16.5145L14.1425 14.0145C13.8584 13.5409 14.0119 12.9267 14.4855 12.6425Z"
      fill="currentColor"
    />
  </svg>
);

export default HideIcon;
